var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransactionHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74284 9C8.42948 8.62057 8.06621 8.28389 7.66308 8H12.5C12.7761 8 13 8.22386 13 8.5C13 8.77614 12.7761 9 12.5 9H8.74284ZM9.40029 10C9.56223 10.3168 9.69436 10.6514 9.79297 11H12.5C12.7761 11 13 10.7761 13 10.5C13 10.2239 12.7761 10 12.5 10H9.40029ZM10 12.5C10 12.6685 9.99242 12.8353 9.97758 13H12.5C12.7761 13 13 12.7761 13 12.5C13 12.2239 12.7761 12 12.5 12H9.97758C9.99242 12.1647 10 12.3315 10 12.5ZM4 2V7.02242C3.65659 7.05337 3.32228 7.11588 3 7.20703V2C3 0.895431 3.89543 0 5 0H9.58579C9.98361 0 10.3651 0.158035 10.6464 0.43934L14.5607 4.35355C14.842 4.63486 15 5.01639 15 5.41421V14C15 15.1046 14.1046 16 13 16H8.74284C8.99647 15.6929 9.21739 15.3578 9.40029 15H13C13.5523 15 14 14.5523 14 14V6H10.5C9.67157 6 9 5.32843 9 4.5V1H5C4.44772 1 4 1.44772 4 2ZM10.5 5H13.7929L10 1.20711V4.5C10 4.77614 10.2239 5 10.5 5ZM4.5 17C6.98528 17 9 14.9853 9 12.5C9 10.0147 6.98528 8 4.5 8C2.01472 8 0 10.0147 0 12.5C0 14.9853 2.01472 17 4.5 17ZM4 10.5C4 10.2239 4.22386 10 4.5 10C4.77614 10 5 10.2239 5 10.5V12H6C6.27614 12 6.5 12.2239 6.5 12.5C6.5 12.7761 6.27614 13 6 13H4.5C4.22386 13 4 12.7761 4 12.5V10.5Z",
    fill: "#2246DC"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionHistory);
export default __webpack_public_path__ + "static/media/transaction-history.742a4329808f60debcb9e1123eba3212.svg";
export { ForwardRef as ReactComponent };